import Checkbox from "@material-ui/core/Checkbox";
import Switch from "rc-switch";
import _ from "lodash";
import { useTranslation } from 'react-i18next';
import styles from "./HomeBlock.module.scss";
import { useEffect } from "react";

function HomeBlock({ home, optimizeState, optimizeDispatch, orderedStops }) {
  const { t } = useTranslation();
  const tBase = "views.appointments.MapComponents.HomeBlock";
  const tr = (key) => t(`${tBase}.${key}`);

  const { address } = home;



  const foundHomeOrder = _.find(optimizeState, { address: address });
  const isHomeStart = foundHomeOrder?.isStart;
  const isHomeEnd = foundHomeOrder?.isEnd;

  const endCount = optimizeState.filter(a => a.isEnd).length;

  const homeLat = home.location.latitude;
  const homeLng = home.location.longitude;

  const homeOrder = orderedStops
    .map((stop, index) =>
      stop.location_metadata.supplied_coordinate[0] === homeLng &&
        stop.location_metadata.supplied_coordinate[1] === homeLat
        ? index + 1
        : null
    )
    .filter((index) => index !== null);

  useEffect(() => {
    if (orderedStops.length > 0) {

    }
  }, [orderedStops]);

  return (
    <div
      className={styles.appointmentRow}
      style={{
        borderLeftColor: "lightgray",
        borderLeftWidth: 15,
      }}
    >
      <div className={styles.countColumn}>
        <div className={styles.orderContainer}>
          {homeOrder.length > 0 && (
            <div className={styles.order}>{homeOrder.join(", ")}</div>
          )}
        </div>

        <div
          onClick={() => {
            if (_.findIndex(optimizeState, { address: address }) === -1) {
              optimizeDispatch({
                type: "ADD",
                payload: {
                  address,
                  center: [home.location.longitude, home.location.latitude],
                },
              });
            } else {
              optimizeDispatch({ type: "REMOVE", payload: { address } });
            }
          }}
          className={styles.countRow}
        >
          <Checkbox
            checked={_.findIndex(optimizeState, { address: address }) > -1}
          />
        </div>
        <div className={styles.timeSwitchGroup}>
          <div className={styles.timeSwitchRow}>
            <Switch
              checked={
                _.find(optimizeState, { address: address }) &&
                _.find(optimizeState, { address: address }).isStart
              }
              onChange={() => {
                if (
                  _.find(optimizeState, { address: address }) &&
                  _.find(optimizeState, { address: address }).isStart
                ) {
                  optimizeDispatch({
                    type: "REMOVE_START",
                    payload: { address },
                  });
                } else {
                  optimizeDispatch({
                    type: "ADD_START",
                    payload: {
                      address,
                      center: [home.location.longitude, home.location.latitude],
                    },
                  });
                }
              }}
            />
            <div className={styles.timeSwitchText}>{tr("Start")}</div>
          </div>
          <div className={styles.timeSwitchRow}>
            <Switch
              checked={
                _.find(optimizeState, { address: address }) &&
                _.find(optimizeState, { address: address }).isEnd
              }
              onChange={() => {
                if (
                  _.find(optimizeState, { address: address }) &&
                  _.find(optimizeState, { address: address }).isEnd
                ) {
                  optimizeDispatch({
                    type: "REMOVE_END",
                  });
                } else {
                  optimizeDispatch({
                    type: "ADD_END",
                    payload: {
                      address,
                      center: [home.location.longitude, home.location.latitude],
                    },
                  });
                }
              }}
            />
            <div className={styles.timeSwitchText}>{tr("End")}</div>
          </div>
        </div>
      </div>

      <div className={styles.detailColumn}>
        <div className={styles.detailRow}>
          <div className={styles.openButtonContainer}></div>
          <div className={styles.column}>
            {address ? (
              <div className={styles.address}>{address}</div>
            ) : (
              <div className={styles.address}>{tr("No Address")}</div>
            )}
          </div>
        </div>
        <div className={styles.newStartRow}>
          <div className={styles.buttonGroupRow}></div>
        </div>
      </div>
    </div>
  );
}

export default HomeBlock;
